import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import anime from 'animejs/lib/anime.es.js';
import { SvgLoaderComponent } from '../../images/svg-loader/svg-loader.component';
import { DeviceService } from 'app/services/device.service';
import { debounceTime, fromEvent, Subscription } from 'rxjs';

@Component({
  selector: 'app-page-overlay',
  standalone: true,
  imports: [CommonModule, SvgLoaderComponent],
  templateUrl: './page-overlay.component.html',
  styleUrl: './page-overlay.component.scss'
})
export class PageOverlayComponent {
  @Output() closeOverlay = new EventEmitter<void>();

  animationComplete: boolean = false;
  private animationTimeline: anime.AnimeTimelineInstance | null = null;
  private resizeSubscription: Subscription;
  overlayReady: boolean = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.overlayReady) return;
  
    const overlay = this.elRef.nativeElement.querySelector('#overlay');
    const target = event.target as Node;
  
    if (!overlay.contains(target)) {
      this.handleCloseOverlay();
    }
  }

  constructor(private deviceService: DeviceService, private elRef: ElementRef) {
    this.setupResizeListener();
  }

  ngAfterViewInit(): void {

    this.animationTimeline = anime.timeline({
      autoplay: false,
    });
    const fullHeight = this.calculateFullHeight();

    this.animationTimeline
      .add({
        targets: '#overlay',
        opacity: [0.5, 1],
        translateY: [20, 0],
        duration: 350,
        easing: 'easeOutSine',
        complete: () => {
          this.animationComplete = true;
          this.overlayReady = true;
        }
      })
      .add({
        targets: '#content',
        height: ['inherit', `${fullHeight}px`],
        width: ['inherit', '1000px'],
        duration: 350,
        easing: 'spring(1, 90, 25, 0)',
        borderRadius: ['40px', '12px'],
      }, '-=350');

    this.animationTimeline.play();
  }

  // Calculate height based on device type
  private calculateFullHeight(): number {
    const isMobile = this.deviceService.getDeviceType() === 'mobile';
    return isMobile ? window.innerHeight - 16 : window.innerHeight - 48;
  }

  // Set up resize listener with debounce
  private setupResizeListener(): void {
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(200)) // Debounce resize events by 200ms
      .subscribe(() => {
        this.updateContentHeight();
      });
  }

  private updateContentHeight(): void {
    const fullHeight = this.calculateFullHeight();
    const contentElement = document.querySelector('#content') as HTMLElement | null;
    if (contentElement) {
      contentElement.style.height = `${fullHeight}px`;

      // if (this.animationTimeline) {
      //   this.animationTimeline.children[1].keyframes.height = ['inherit', `${fullHeight}px`];
      // }
    }
  }

  handleCloseOverlay() {
    this.closeOverlay.emit();
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
      document.removeEventListener('click', this.onDocumentClick);
  }

}
